__turbopack_context__.v({
  "act-btn-con": "miniQuickActions-module-scss-module__ekRyEW__act-btn-con",
  "act-card": "miniQuickActions-module-scss-module__ekRyEW__act-card",
  "act-card-con": "miniQuickActions-module-scss-module__ekRyEW__act-card-con",
  "act-img-con": "miniQuickActions-module-scss-module__ekRyEW__act-img-con",
  "action-image": "miniQuickActions-module-scss-module__ekRyEW__action-image",
  "actions-main-con": "miniQuickActions-module-scss-module__ekRyEW__actions-main-con",
});
